import React, {useRef} from "react";
import {useSnapshot} from "valtio";
import {configuratorState, state, arState, cameraState} from "../../state";
import {Box, OrbitControls} from "@react-three/drei";
import ARController from "../ar/ARController";
import CamaraController from "../camera/CamaraController";
import CamaraPosRecorder from "../camera/CamaraPosRecorder";
import MaterialDevControls from "../materials/MaterialDevControls";
import MultiModelLoader from "../loaders/MultiModelLoader";

const ModelsContainer = () => {
  
  const {arEnabled, autoRotate} = useSnapshot(state);
  const {getGroupVis} = useSnapshot(arState);
  const {developerControlsStatus} = useSnapshot(cameraState);
  const {materialsDeveloperControls} = useSnapshot(configuratorState);
  
  let group = useRef();
  let recticel = useRef();
  let orbit = useRef();
  
  return (
    <>
      <group ref={group}>
        <group visible={getGroupVis}>
          <MultiModelLoader camera={orbit}/>
        </group>
        <Box ref={recticel} args={[0.1, 0.01, 0.1]} visible={!getGroupVis}/>
      </group>
  
      <OrbitControls ref={orbit} autoRotate={autoRotate} autoRotateSpeed={7.5} target={[10,10,10]}/>
      {(arEnabled) && (<ARController group={group} orbit={orbit}/>)}
      <CamaraController orbit={orbit}/>
      {(developerControlsStatus) && (<CamaraPosRecorder orbit={orbit}/>)}
      {(materialsDeveloperControls) && (<MaterialDevControls/>)}
    </>
  );
}

export default ModelsContainer;
